//Ez a komponens a keresési eredmények megjelenítéséért felelős, a SearchExercises komponenssel együtt használható.

import React from 'react';
import SearchExercises from '../components/SearchExercises';
import ExerciseResults from '../components/ExerciseResults';
import { Exercise } from '../utils/types';

// WorkoutsPageProps interfész definiálása, amely meghatározza a WorkoutsPage komponens által elvárt propsokat
interface WorkoutsPageProps {
  exercises: Exercise[];  // A gyakorlatok listája
  setExercises: React.Dispatch<React.SetStateAction<Exercise[]>>;  // A gyakorlatok listáját frissítő függvény
  bodyPart: string;  // Az éppen kiválasztott testrész
  setBodyPart: React.Dispatch<React.SetStateAction<string>>;  // A testrész állapotát frissítő függvény
}

// WorkoutsPage komponens definiálása, amely a propsok segítségével jeleníti meg a gyakorlatokat
const WorkoutsPage: React.FC<WorkoutsPageProps> = ({ exercises, setExercises, bodyPart, setBodyPart }) => {
  return (
    <div>
      {/* SearchExercises komponens, amely lehetővé teszi a gyakorlatok keresését és frissíti a kiválasztott testrészt */}
      <SearchExercises setExercises={setExercises} bodyPart={bodyPart} setBodyPart={setBodyPart} />

      {/* ExerciseResults komponens, amely megjeleníti a keresési eredményeket; tartalmazza az ExerciseCard-ot */}
      <ExerciseResults exercises={exercises} />
    </div>
  );
};

export default WorkoutsPage;
